export default __webpack_public_path__ + "static/media/Prosthodontics.3d859f33.png";